require('jquery-pjax');
const NProgress = require('nprogress');

NProgress.configure({
    showSpinner: false,
    easing: 'ease-out',
    speed: 1000
});

$(document).pjax('a:not(.fancybox):not([target="_blank"])', '#main', {
    scrollTo: $('.main').position().top - 60,
    fragment: '#main',
    timeout: 16000,
});

$(document).on('pjax:start', function(e) {

    // if (window.dplayers) {
    //   for (let i = 0; i < window.dplayers.length; i++) {
    //       window.dplayers[i].destroy();
    //   }
    //   window.dplayers = [];
    // }
    if (window.aplayers) {
        for (let i = 0; i < window.aplayers.length; i++) {
            window.aplayers[i].destroy();
        }
        window.aplayers = [];
    }

    if (CONFIG.serviceWorkerUpdated && e.relatedTarget) {
        // serviceWorder 更新后，点击链接时跳转页面，刷新资源
        // console.log(e.relatedTarget.href)
        location.href = e.relatedTarget.href
    } else {
        NProgress.start();
        $('html, body').animate({
            scrollTop: $('.main').position().top - 60
        }, 500);
    }
});

$(document).on('pjax:end', function() {
    console.log('pjax:end')
    typeof initDiscusJS === 'function' && initDiscusJS()
    NProgress.done();
    require('./post-details')();
    require('./leancloud')();
    require('./share')();
    require('./pisces')();
    // require('./zoom')();
    require('./fancybox')();
    require('./encript-blog')();
    window.originTitle = document.title;

    var url = decodeURIComponent(window.location.href);
    if (typeof ga === 'function') {
        ga('set', 'location', url);
        ga('set', 'title', document.title);
        ga('send', 'pageview');
    }
    if (typeof _paq === "object" && typeof _paq.push === 'function') {
        _paq.push(['setCustomUrl', url]);
        _paq.push(['setDocumentTitle', document.title]);
        // remove all previously assigned custom variables, requires Matomo (formerly Piwik) 3.0.2
        _paq.push(['deleteCustomVariables', 'page']);
        // _paq.push(['setGenerationTimeMs', 0]);
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
    }
});
$(window).on('load', function() {
    console.log('window:load')
    typeof initDiscusJS === 'function' && initDiscusJS()

    if (!['localhost'].includes(location.hostname)) {
        window.webviewSDKCfg = {
            bgColor: '#78797a'
        };
        typeof initAplayer === 'function' && initAplayer();
        var src = ['https://kainy.cn/js/common.js', 'https://chimpstatic.com/mcjs-connected/js/users/bff30e7ea031c8e39972b69d4/b5f20d379ba323b65f864220a.js'];
        for (var i = src.length; i > 0; i--) {
            var c = document.createElement('script');
            c.type = 'text/javascript';
            c.defer = true;
            c.src = src[i - 1];
            var h = document.getElementsByTagName('script')[0];
            h.parentNode.insertBefore(c, h);
        }
    }
    window.document.body.onbeforeunload = function() {
        if (CONFIG.apFixed && !CONFIG.apFixed.audio.paused && !CONFIG.serviceWorkerUpdated) {
            return '页面跳转将导致音乐终止，确定要离开本页吗？'
        }
    }
})